import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { Button, Paper, Grid, IconButton, Card } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { generateClient } from "aws-amplify/api";
import { listSeasons } from "../../graphql/queries";
import { deleteSeason } from "../../graphql/mutations";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomDataGrid from "../../components/CustomDataGrid";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
  dataGridContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  dataGrid: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: "100%",
  },
}));

const Seasons = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const client = generateClient();
  const [seasons, setSeasonsList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSeasons();
  }, []);

  const fetchSeasons = async () => {
    try {
      setLoading(true);
      const response = await client.graphql({
        query: listSeasons,
      });
      const seasonsList = response.data.listSeasons.items;
      setSeasonsList(seasonsList);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 1, hide: true },
    // { field: 'seriesID', headerName: 'Series ID', flex: 1 },
    { field: "title", headerName: "Title", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <IconButton
          color="error"
          onClick={() => deleteSeasonById(params.row.id)}
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
  ];

  const deleteSeasonById = async (seasonId) => {
    try {
      await client.graphql({
        query: deleteSeason,
        variables: { input: { id: seasonId } },
      });

      fetchSeasons();
    } catch (err) {
      console.log("Error deleting Season:", err);
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <Button
          variant="contained"
          onClick={() => navigate("/create/seasons")}
          sx={{
            width: { xs: "100%", md: "200px" },
            backgroundColor: "#000d1a",
            color: "white",
            fontWeight: "bold",
            borderRadius: "8px",
          }}
        >
          Create Season
        </Button>
      </Grid>
      <Card sx={{ marginTop: 2 }}>
        <Grid item xs={12}>
          <div className={classes.dataGridContainer}>
            <CustomDataGrid
              rows={seasons}
              columns={columns}
              pageSize={10}
              loading={loading}
            />
          </div>
        </Grid>
      </Card>
    </>
  );
};

export default Seasons;
